var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mb-32"},[_vm._v("Общая информация")]),_c('div',{staticClass:"stack-md"},[_c('w-info'),_c('w-access'),_c('w-start')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }